import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { AppRouter } from './router';
import "./App.css";

const App = () => (
  <AuthProvider>
    <Router>
      <AppRouter />
    </Router>
  </AuthProvider>
);

export default App;
